import React from 'react';
import PropTypes from 'prop-types';
import { CreditCard } from 'lucide-react';

/*
 * Brand chips drawn with type and CSS rather than trademarked vector art,
 * sized to match the icon slot of Stripe's CardElement.
 */

const Chip = ({ label, children, className = '' }) => (
  <span
    role="img"
    aria-label={label}
    className={`flex h-[26px] w-[38px] shrink-0 items-center justify-center rounded border border-gray-100 dark:border-border bg-white dark:bg-background ${className}`}
  >
    {children}
  </span>
);

Chip.propTypes = {
  label: PropTypes.string.isRequired,
  children: PropTypes.node,
  className: PropTypes.string,
};

const brands = {
  visa: (
    <Chip label="Visa">
      <span className="text-[11px] font-extrabold italic tracking-tight text-[#1A1F71] dark:text-foreground">
        VISA
      </span>
    </Chip>
  ),
  mastercard: (
    <Chip label="Mastercard">
      <span className="flex">
        <span className="h-3.5 w-3.5 rounded-full bg-[#EB001B]" />
        <span className="-ml-1.5 h-3.5 w-3.5 rounded-full bg-[#F79E1B] opacity-90" />
      </span>
    </Chip>
  ),
  amex: (
    <Chip label="American Express" className="border-[#006FCF] bg-[#006FCF]">
      <span className="text-[9px] font-extrabold tracking-tight text-white">AMEX</span>
    </Chip>
  ),
  discover: (
    <Chip label="Discover">
      <span className="text-[8px] font-extrabold tracking-tight text-[#231F20] dark:text-foreground">
        DISC<span className="text-[#FF6000]">O</span>VER
      </span>
    </Chip>
  ),
};

const CardBrandIcon = ({ brand }) =>
  brands[brand] || (
    <Chip label="Card">
      <CreditCard className="h-4 w-4 text-gray-400 dark:text-muted-foreground" />
    </Chip>
  );

CardBrandIcon.propTypes = {
  brand: PropTypes.string,
};

export default CardBrandIcon;
